<main class="p-4 bg-white shadow-lg rounded-2xl h-full flex flex-col items-center">
  <section class="w-full flex-1 flex items-center justify-between">
    <article class="w-full flex flex-1 items-center justify-items-start gap-4">
      @if (loading()) {
      <div class="w-full pe-4">
        <p-skeleton class="mb-4" />
        <p-skeleton height="2rem" />
      </div>
      } @else {
      <div class="border-l-4 pl-4 border-background-dark">
        @if (descriptionLight()) {
        <div class="text-zinc-400 text-sm">{{ descriptionLight() }}</div>
        }
        <div class="text-2xl font-bold text-zinc-900">
          {{ selectedState === stateOptionsEnum.day ? dayValue() : monthValue() }}
        </div>
      </div>
      }
    </article>
    @if (loading()) {
    <p-skeleton shape="square" size="4rem" />
    } @else {
    <div>
      <p-selectbutton [options]="stateOptions" [(ngModel)]="selectedState" (onChange)="onStateChange($event.value)"
        size="small" [required]="true" [allowEmpty]="false" />
    </div>
    }
  </section>
  <section class="w-full flex items-center">
    @if (loading()) {
    <article class="w-full mt-4">
      <p-skeleton />
    </article>
    }
  </section>
</main>
